import {useEffect, useRef} from 'react'

type UseScrollEndProps = {
  onScrollEnd: () => void
  offset?: number
}

export const useScrollEnd = <T extends HTMLElement>({
  onScrollEnd,
  offset = 0
}: UseScrollEndProps) => {
  const containerRef = useRef<T | null>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      if (container.scrollHeight - container.scrollTop <= container.clientHeight + offset) {
        onScrollEnd()
      }
    }

    container.addEventListener('scroll', handleScroll)
    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [onScrollEnd, offset])

  return containerRef
}
